import React from 'react';
import MenuItemCard from './MenuItemCard';

const MenuGrid = ({ items, onOrderClick, onFavoriteToggle }) => {
  if (items?.length === 0) {
    return (
      <div className="text-center py-16 md:py-20">
        <div className="w-20 h-20 md:w-24 md:h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-4xl md:text-5xl">🍽️</span>
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2">No items found</h3>
        <p className="text-sm md:text-base text-muted-foreground">Try adjusting your filters or search query</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
      {items?.map((item) => (
        <MenuItemCard
          key={item?.id}
          item={item}
          onOrderClick={onOrderClick}
          onFavoriteToggle={onFavoriteToggle}
        />
      ))}
    </div>
  );
};

export default MenuGrid;